import { useEffect, useState } from "react";
import { Category } from "../models/EventModel";

type CacheEntry = {
    categories: Category[];
    ts: number;
};

let categoriesCache: CacheEntry = { categories: [], ts: 0 };

export function useCategories(options?: { maxAgeMs?: number }) {

    const maxAgeMs = options?.maxAgeMs ?? (60000 * 60); // 1h

    const cached = categoriesCache;
    const [categories, setCategories] = useState<Category[]>(cached?.categories ?? []);
    const [loading, setLoading] = useState<boolean>(cached.categories.length === 0);

    useEffect(() => {
        const now = Date.now();
        const cacheHit = categoriesCache;
        const fresh = cacheHit.categories.length > 0 && now - cacheHit.ts < maxAgeMs;

        if (fresh) {
            setCategories(cacheHit!.categories);
            setLoading(false);
            return;
        }

        fetchCategories();
    }, []);

    const fetchCategories = () => {
        setLoading(true);
        return new Promise<void>(async (resolve, reject) => {
            try {
                let fetchUrl = '/api/events/categories';
                const response = await fetch(fetchUrl);
                const data = await response.json()
                categoriesCache = { categories: data, ts: Date.now() };
                setCategories(data);
                setLoading(false);
                resolve();
            } catch (error) {
                console.error('Error fetching events:', error);
                setLoading(false);
                reject();
            }
        });

    }

    return {
        categories,
        loading
    };

}
